// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_Sdb","cls2":"LoswpPackPitch-cls2_TK9 LoswpPackPitch-cls1_Sdb"};